export default function CsharpMethods() {
  return (
    <h2>Csharp Methods</h2>
  );
}
